import { StyleSheet } from 'react-native-unistyles';

export const styles = StyleSheet.create((colors) => ({
  separator: {
    height: 1,
    width: '100%',
    backgroundColor: colors.borderPrimary,
  },
}));
